"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sandwichIds = void 0;
var sandwichIds = {
    summary: {
        noData: 'usage-noDataError-image',
    },
    usagePage: {
        topStats: 'oep-usage-top-stats',
    },
};
exports.sandwichIds = sandwichIds;
